import { render, staticRenderFns } from "./pabauTab.vue?vue&type=template&id=5c145569"
import script from "./pabauTab.vue?vue&type=script&lang=js"
export * from "./pabauTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports